import { render } from "./linbaoDetail.vue?vue&type=template&id=56d02d20"
import script from "./linbaoDetail.vue?vue&type=script&lang=js"
export * from "./linbaoDetail.vue?vue&type=script&lang=js"

import "./linbaoDetail.vue?vue&type=style&index=0&id=56d02d20&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__